/**
 * `offers` — les offres faites à un contact (base galerie, 4.1) [palier Galerie].
 */
import { z } from 'zod';
import { CHAMPS_DOCUMENT, centimesPositifsSchema, deviseSchema, idSchema, withAudit, } from './commun.js';
export const ETATS_OFFRE = [
    'brouillon',
    'envoyee',
    'acceptee',
    'refusee',
    'expiree',
    // Retirée par la galerie (œuvre vendue à un autre, erreur de saisie).
    'retiree',
];
export const etatOffreSchema = z.enum(ETATS_OFFRE);
/** Comment l'offre a été faite : par courriel, au stand, remise de la main à la main. */
export const CANAUX_OFFRE = ['courriel', 'stand', 'remise'];
export const canalOffreSchema = z.enum(CANAUX_OFFRE);
export const ligneOffreSchema = z.object({
    oeuvreId: idSchema,
    exemplaireId: idSchema.optional(),
    designation: z.string().min(1),
    prixProposeCentimes: centimesPositifsSchema,
});
export const offerSchema = withAudit(z.object({
    _id: idSchema,
    numero: z.string().optional(),
    contactId: idSchema,
    lignes: z.array(ligneOffreSchema).min(1),
    devise: deviseSchema.default('EUR'),
    validiteJusquau: z.date(),
    message: z.string().optional(),
    etat: etatOffreSchema.default('brouillon'),
    envoyeeLe: z.date().optional(),
    relanceeLe: z.date().optional(),
    canal: canalOffreSchema.optional(),
    expositionId: idSchema.optional(),
    relancePrevueLe: z.date().optional(),
    accepteeLe: z.date().optional(),
    refuseeLe: z.date().optional(),
    retireeLe: z.date().optional(),
    expireeLe: z.date().optional(),
    motif: z.string().optional(),
    reservationIds: z.array(idSchema).default([]),
    factureId: idSchema.optional(),
}));
export const offerCreationSchema = offerSchema.omit({
    ...CHAMPS_DOCUMENT,
    numero: true,
    etat: true,
    envoyeeLe: true,
    relanceeLe: true,
    canal: true,
    accepteeLe: true,
    refuseeLe: true,
    retireeLe: true,
    expireeLe: true,
    reservationIds: true,
    factureId: true,
});
export const offerMiseAJourSchema = offerCreationSchema.partial();
//# sourceMappingURL=offers.js.map